import React from 'react';
import { Guard } from './Guard';
import { DefaultGuardModel } from './DefaultGuardModel';
var GuardContextValue = /** @class */ (function () {
    function GuardContextValue(guard) {
        if (guard === void 0) { guard = new Guard(new DefaultGuardModel(), [], {}); }
        this.guard = guard;
    }
    return GuardContextValue;
}());
export { GuardContextValue };
export var GuardContext = React.createContext(new GuardContextValue());
export var GuardResourceContext = React.createContext({ resourceName: '' });
//# sourceMappingURL=context.js.map